import { useEffect, useState } from 'react';
import { useUIStore } from '@/state/useUIStore';
import { useInventoryStore } from '@/state/useInventoryStore';
import './Inventory.css';

export function Inventory() {
  const { closeInventory, showInventory } = useUIStore();
  const { items, fetchInventory, equipItem, loading, error } = useInventoryStore();
  const [equipping, setEquipping] = useState<string | null>(null);

  // Fetch inventory when panel opens
  useEffect(() => {
    if (showInventory) {
      fetchInventory();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showInventory]);

  if (!showInventory) return null;

  const handleEquip = async (itemId: string) => {
    setEquipping(itemId);
    try {
      await equipItem(itemId);
    } finally {
      setEquipping(null);
    }
  };

  // Filter to only owned items
  const ownedItems = items.filter(i => i.owned);

  // Group by type
  const flagItems = ownedItems.filter(i => i.itemType === 'flag');

  return (
    <div className="inventory-overlay" onClick={closeInventory}>
      <div className="inventory-modal" onClick={(e) => e.stopPropagation()}>
        <header className="inventory-header">
          <h2>INVENTORY</h2>
          <button className="close-btn" onClick={closeInventory}>×</button>
        </header>

        <div className="inventory-content">
          {loading && <div className="inventory-loading">Loading inventory...</div>}
          {error && <div className="inventory-error">{error}</div>}

          {/* Flag Skins Section */}
          <section className="inventory-section">
            <h3 className="section-title">Flag Skins</h3>
            
            {flagItems.length === 0 ? (
              <div className="empty-section">
                <p>No flag skins owned yet.</p>
                <p className="hint">Visit the Shop to purchase flag skins!</p>
              </div>
            ) : (
              <div className="inventory-grid">
                {flagItems.map((item) => (
                  <div 
                    key={item.itemId} 
                    className={`inventory-item ${item.equipped ? 'equipped' : ''}`}
                  >
                    <div className="item-preview">
                      <span className="preview-icon">🚩</span>
                    </div>
                    <div className="item-details">
                      <span className="item-name">{item.name}</span>
                      {item.equipped && (
                        <span className="equipped-badge">Equipped</span>
                      )}
                    </div>
                    <button
                      className={`equip-btn ${item.equipped ? 'unequip' : ''}`}
                      onClick={() => handleEquip(item.itemId)}
                      disabled={equipping === item.itemId || item.equipped}
                    >
                      {equipping === item.itemId ? (
                        <span className="spinner" />
                      ) : item.equipped ? (
                        'Equipped'
                      ) : (
                        'Equip'
                      )}
                    </button>
                  </div>
                ))}
              </div>
            )}
          </section>
        </div>

        <footer className="inventory-footer">
          <div className="inventory-stats">
            <span>Total Items: {ownedItems.length}</span>
          </div>
        </footer>
      </div>
    </div>
  );
}
